<!-- 佣金记录 -->
<template>
  <div id="commission-page">
    <!-- header start -->
    <van-nav-bar
      title=""
      left-arrow
      :border="false"
      @click-left="goBack"
      :safe-area-inset-top="true"
      fixed
      :placeholder="true"
      :z-index="99"
    />
    <div class="commission-area-box">
      <img src="~@/assets/images/top-bg-2.png" alt="" class="bg" />
      <div class="profit-box">
        <div class="bd">
          <div class="check-date" @click="commissionDateShow = true">
            <div class="month">{{ month }}月</div>
            <div class="year">{{ year }}年</div>
            <van-icon name="arrow-down" size="12" color="#fff" />
          </div>
          <div class="profit-details-box" v-if="memberData != null">
            <div class="thead">
              <img :src="memberData.headPic" alt="" class="avatar" />
              <div class="memeber-name">{{ memberData.nickName }}</div>
            </div>
            <div class="profit-total">
              <div class="profit-total-tit">总获团队奖金(元)</div>
              <div class="profit-total-price">{{ totalPrice }}</div>
            </div>
            <!-- <div class="tuandui-box">
              代理地区：{{
                memberData.memberAgentCommission != null
                  ? memberData.memberAgentCommission.cityName
                  : ""
              }}
            </div> -->
          </div>
        </div>
      </div>

      <div class="daili-box">
        <CommissionTeamItem
          :time="year + '-' + month + '-' + 1"
        ></CommissionTeamItem>
      </div>
    </div>

    <!-- 日期 popup start -->
    <van-popup v-model="commissionDateShow" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="commissionDateShow = false"
        @cancel="commissionDateShow = false"
        @change="commissionDateChange"
      />
    </van-popup>
    <!-- 日期 popup end -->
  </div>
</template>

<script>
import common from "../../tools/common";
import { DatetimePicker } from "vant";
import CommissionTeamItem from "../../components/CommissionTeamItem.vue";

export default {
  data() {
    return {
      totalPrice: 0,
      tabActive: 0,
      commissionDateShow: false,
      minDate: new Date(2019, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      memberData: null,
    };
  },
  components: {
    [DatetimePicker.name]: DatetimePicker,
    CommissionTeamItem
  },
  methods: {
    init() {
      var _time = this.year + "-" + this.month + "-1";
      // this.GetAgent(this.GetSumTeamCommission(_time));
      this.GetSumTeamCommission(_time);
    },
    GetSumTeamCommission(time) {
      var that = this;
      this.$store
        .dispatch({
          type: "GetSumTeamCommission",
          time: time
        })
        .then(res => {
          // console.log(res,"GetSumTeamCommission");
          that.totalPrice = res;
        });
    },
    // GetAgent(callback) {
    //   var that = this;
    //   that.$store
    //     .dispatch({
    //       type: "GetAgent"
    //     })
    //     .then(res => {
    //       common.Response.callNotMsgResponse(res, function(result) {
    //         that.memberData = result;
    //         if (callback) {
    //           callback();
    //         }
    //       });
    //     });
    // },
    // goCommissionPage() {
    //   this.$router.push("/commissionDetails");
    // },
    commissionDateChange(picker, value, index) {
      let dateArray = picker.getValues();
      this.year = dateArray[0];
      this.month = dateArray[1];
      //this.commissionDate = dateArray.join("-");
      var _time = this.year + "-" + this.month + "-1";
      this.GetSumTeamCommission(_time);
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == "User") {
      to.meta.refresh = true;
    } else {
      to.meta.refresh = false;
    }
    next();
  },
  activated() {
    // console.log(this.$route.meta.refresh)
    // if (this.$route.meta.refresh) {
    //    this.init();
    // }
  },
  created() {
    var that = this;
    var _currenMember = localStorage.getItem("member");
    that.memberData=JSON.parse(_currenMember);
    that.init();
  },
};
</script>
<style lang="less" scoped>
.commission-area-box {
  width: 100%;
  height: auto;
  padding-bottom: 10.5px;
  position: relative;
}

.commission-area-box > .bg {
  width: 100%;
  display: block;
  position: absolute;
  top: 0;
  background-size: 100% 100%;
  height: 115px;
}
.grade-btn {
  margin-left: 15px;
  line-height: 1;
  font-size: 10px;
  color: #f6ae33;
  border: 1px solid;
  width: 68px;
  padding: 4px 0;
  text-align: center;
  border-radius: 999px;
}
.profit-box {
  position: relative;
  margin: 0 16px 16px;
  .bd {
    .check-date {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      justify-content: flex-end;
      .month {
        font-size: 15px;
        color: #fff;
      }
      .year {
        margin-left: 12px;
        font-size: 12px;
        color: #fff;
        margin-right: 6px;
      }
    }
    //佣金详情
    .profit-details-box {
      background: #fff;
      border-radius: 6px;
      padding: 12px 14px;
      .thead {
        display: flex;
        align-items: center;
        position: relative;
        .avatar {
          width: 65px;
          height: 65px;
          object-fit: cover;
          border-radius: 50%;
          margin-right: 12px;
          border: 3px solid #fff;
          position: relative;
          margin-top: -36px;
          margin-left: -14px;
        }
        .memeber-name {
          font-size: 14px;
          color: #000;
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .profit-total {
        text-align: center;
        margin-top: 20px;
        margin-bottom: 25px;
        .profit-total-tit {
          font-size: 10px;
          color: #1d1d1d;
        }
        .profit-total-price {
          font-size: 21px;
          color: #ff565c;
          margin-top: 10px;
        }
      }
      .tuandui-box {
        display: flex;
        align-items: center;
        .turandui-item {
          flex: 1;
          position: relative;
          font-size: 12px;
          color: #393939;
          padding: 0 15px;
          text-align: center;
          .hlight {
            color: #ff0030;
          }
          &:first-child:after {
            content: "";
            position: absolute;
            top: 50%;
            right: 0;
            width: 2px;
            height: 12px;
            margin-top: -6px;
            background: #555;
            border-radius: 999px;
          }
        }
      }
    }
  }
}
//佣金记录-下级用户
.daili-box {
  margin: 10px;
  background: #fff;
  border-radius: 6px;
  padding: 12px 16px;
}
.daili-item {
  display: flex;
  padding: 15px 0;
  .th {
    margin-right: 12px;
    .avatar {
      width: 52px;
      height: 52px;
      object-fit: cover;
      border-radius: 50%;
    }
  }
  .bd {
    flex: 1;
    overflow: hidden;
    .thead {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .member-name {
        font-size: 14px;
        color: #000;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .tuandui-num {
        margin-left: 15px;
        font-size: 12px;
        color: #666;
        flex-shrink: 0;
        .hlight {
          color: #ff565c;
        }
      }
      .grade-btn {
        // align-content: flex-end;
      }
    }
    .tbody {
      margin-top: 10px;
      display: flex;
      align-items: center;
      .yeji-item {
        flex: 1;
        overflow: hidden;
        .yeji-tit {
          font-size: 10px;
          color: #ababab;
        }
        .yeji-num {
          font-size: 13px;
          color: #ff565c;
          margin-top: 4px;
        }
      }
    }
  }
}
</style>
<style lang="less">
#commission-page {
  .van-nav-bar {
    background-image: url("~@/assets/images/top-bg-1.png");
    background-size: 100% 100%;
  }
  .van-nav-bar .van-icon {
    color: #fff;
    font-size: 20px;
  }
  .van-nav-bar__title {
    color: #fff;
  }
}
</style>
